<p-card class="p-4 shadow-lg rounded-lg">
  <p> Administración de usuarios </p>
  <p class="mb-4 text-gray-700">Busca un usuario para modificar sus permisos y roles</p>

  <h3 class="text-xl font-bold mb-4">1) Buscar Usuario</h3>

  <div class="flex flex-col md:flex-row gap-4 mb-6">
    <input [formControl]="formGroup.controls.email" pInputText type="text" placeholder="Email" (keydown.enter)="getUserClaims()" />

    @if(!existingUser()){
    <div class="mt-4 md:mt-0 text-gray-600">
      <p> Enter para iniciar </p>
    </div>
    } @else {
    <button pButton pRipple [disabled]="formGroup.controls.email.invalid" (click)="getUserClaims()" nbButton status="primary" label="Buscar usuario"></button>
    }
  </div>

  @if(existingUser()){
  <hr class="my-6 border-t border-gray-300" />

  <div class="mb-6">
    <h3 class="text-xl font-bold mb-4">Modificar Permisos</h3>

    <div class="space-y-4">
      <div>
        <label class="block text-gray-700 mb-1">Selecciona permiso</label>
        <p-dropdown
          [options]="permissionsOptions"
          optionLabel="name"
          optionValue="value"
          [showClear]="true"
          placeholder="Permisos"
          [ngModel]="permissionInput().type"
          (ngModelChange)="updatePermissionInput('type', $event)"
          class="w-full"></p-dropdown>
      </div>

      <div>
        <label class="block text-gray-700 mb-1">Selecciona una fecha (selector o calendario solo uno)</label>
        <div class="flex flex-col md:flex-row gap-4">
          <p-dropdown
            [options]="expireDateOptions"
            optionLabel="name"
            optionValue="value"
            [showClear]="true"
            placeholder="Fecha de expiración"
            [ngModel]="permissionInput().expMonths"
            (ngModelChange)="updateExpMonthsAndCalculate(permissionInput, $event === null ? null : +$event)"
            class="w-full md:w-auto"></p-dropdown>

          <p-calendar
            [ngModel]="permissionInput().exp"
            (ngModelChange)="updatePermissionInput('exp', $event); updatePermissionInput('expMonths', null)"
            [showIcon]="true"
            class="w-full md:w-auto"></p-calendar>
        </div>
      </div>

      <div>
        <label class="block text-gray-700 mb-1">Opcional Número de unidades</label>
        <input
          [ngModel]="permissionInput().num"
          (ngModelChange)="updatePermissionInput('num', $event === null ? null : +$event)"
          pInputText
          type="number"
          placeholder="Unidades"
          class="p-2 border rounded w-full md:w-auto" />
      </div>

      <button
        [disabled]="!permissionInput().type || !existingUser()"
        pButton
        pRipple
        class="p-button-success w-full md:w-auto"
        (click)="addPermissionFormGroup()"
        nbButton
        status="primary"
        label="Agregar Permiso"></button>
    </div>

    <div class="mt-6 space-y-2">
      @if (isPermissionsEmpty()) {
      <div class="text-gray-600"> 👉 No tiene Permisos adicionales </div>
      } @for (iter of formGroup.controls?.permissions?.controls | keyvalue; track iter.key) {
      <div class="flex items-center justify-between p-2 border rounded bg-gray-50">
        <div class="flex items-center gap-2">
          <p-button (click)="removeControl('permissions', iter.key)" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger"></p-button>
          <div>
            <b class="font-semibold">Permiso {{ iter.key | permissionName }}</b>
            - @if ($any(iter.value).value?.exp) {
            <!-- Access FormControl value -->
            <span>Expira: {{ $any(iter.value).value.exp | date : 'short' }}</span>
            <!-- Display date if exp exists -->
            } @else {
            <span>No Expira</span>
            } @if ($any(iter.value).value?.num !== null) {
            <!-- Check for num property -->
            <span> ({{ $any(iter.value).value.num }} unidades)</span>
            <!-- Display units if num exists -->
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <hr class="my-6 border-t border-gray-300" />

  <div class="mb-6">
    <h3 class="text-xl font-bold mb-4">Modificar Roles</h3>

    <div class="space-y-4">
      <div>
        <label class="block text-gray-700 mb-1">Selecciona rol</label>
        <p-dropdown
          [options]="rolOptions"
          optionLabel="name"
          optionValue="value"
          [showClear]="true"
          placeholder="Roles"
          [ngModel]="rolInput().type"
          (ngModelChange)="updateRolInput('type', $event)"
          class="w-full"></p-dropdown>
      </div>

      <div>
        <label class="block text-gray-700 mb-1">Selecciona una fecha (selector o calendario solo uno)</label>
        <div class="flex flex-col md:flex-row gap-4">
          <p-dropdown
            [options]="expireDateOptions"
            optionLabel="name"
            optionValue="value"
            [showClear]="true"
            placeholder="Fecha de expiración"
            [ngModel]="rolInput().expMonths"
            (ngModelChange)="updateExpMonthsAndCalculate(rolInput, $event === null ? null : +$event)"
            class="w-full md:w-auto"></p-dropdown>

          <p-calendar
            [ngModel]="rolInput().exp"
            (ngModelChange)="updateRolInput('exp', $event); updateRolInput('expMonths', null)"
            [showIcon]="true"
            class="w-full md:w-auto"></p-calendar>
        </div>
      </div>

      <button
        [disabled]="!rolInput().type || !existingUser()"
        pButton
        pRipple
        class="p-button-success w-full md:w-auto"
        (click)="addRolFormGroup()"
        nbButton
        status="primary"
        label="Agregar Rol"></button>
    </div>

    <div class="mt-6 space-y-2">
      @if (formGroup.controls?.roles?.controls && this.isObjectEmpty(formGroup.controls.roles.controls)) {
      <div class="text-gray-600"> 👉 No tiene Roles </div>
      } @for (iter of formGroup.controls?.roles?.controls | keyvalue; track iter.key) {
      <div class="flex items-center justify-between p-2 border rounded bg-gray-50">
        <div class="flex items-center gap-2">
          <p-button (click)="removeControl('roles', iter.key)" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger"></p-button>
          <div>
            <b class="font-semibold">👉 Rol {{ iter.key }}</b>
            @if ($any(iter.value).value) {
            <!-- Access FormControl value -->
            <span>Expira: {{ $any(iter.value).value | date : 'short' }}</span>
            <!-- Display date -->
            } @else {
            <span>No Expira</span>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <hr class="my-6 border-t border-gray-300" />

  <div class="mb-6">
    <h3 class="text-xl font-bold mb-4">Cambia el plan</h3>

    <div class="flex flex-col md:flex-row gap-4 mb-4">
      <p-dropdown
        [options]="planOptions"
        [ngModel]="planInput().type"
        (ngModelChange)="updatePlanInput('type', $event)"
        optionLabel="name"
        optionValue="value"
        [showClear]="true"
        placeholder="Tipo de plan"
        class="w-full md:w-auto" />

      <p-dropdown
        [options]="expireDateOptions"
        optionLabel="name"
        optionValue="value"
        [showClear]="true"
        placeholder="Fecha de expiración"
        [ngModel]="planInput().expMonths"
        (ngModelChange)="updateExpMonthsAndCalculate(planInput, $event === null ? null : +$event)"
        class="w-full md:w-auto" />
    </div>

    <button
      [disabled]="!planInput().type || !existingUser()"
      pButton
      pRipple
      class="p-button-success w-full md:w-auto"
      (click)="changePlan()"
      nbButton
      status="primary"
      label="Cambiar plan"></button>

    @if (formGroup.controls?.plan) {
    <div class="mt-4 p-2 border rounded bg-gray-50"> Plan Actual: {{ formGroup.controls?.plan.value | json }} </div>
    }
  </div>

  <div class="mb-6">
    <h3 class="text-xl font-bold mb-4">Refrescar Token</h3>
    <h6>Tan pronto como el usuario se conecte al backend, se refrescará su token/permisos</h6>
    <div class="flex flex-col md:flex-row gap-4 mb-4">
      <p-dropdown
        [options]="statusOptions"
        [formControl]="formGroup.controls.status"
        optionLabel="name"
        optionValue="value"
        [showClear]="true"
        placeholder="Seleccionar Estado"
        class="w-full md:w-auto" />
    </div>
  </div>
  <!-- End Status Section -->

  <hr class="my-6 border-t border-gray-300" />

  <div class="mb-6">
    <button
      pButton
      pRipple
      class="p-button-success w-full md:w-auto"
      [disabled]="formGroup.invalid || !existingUser()"
      (click)="updateUser()"
      nbButton
      status="primary"
      label="Actualizar todo"></button>
  </div>

  <hr class="my-6 border-t border-gray-300" />

  }

  <div>
    <h3 class="text-xl font-bold mb-4">Eliminar usuario</h3>

    <div class="flex flex-col md:flex-row gap-4">
      <input
        [ngModel]="deleteUserForm()"
        (ngModelChange)="deleteUserForm.set($event)"
        pInputText
        type="text"
        placeholder="Email"
        (keydown.enter)="deleteUser()"
        class="p-2 border rounded w-full md:w-auto" />

      <button
        pButton
        pRipple
        class="p-button-danger w-full md:w-auto"
        [disabled]="!deleteUserForm()"
        (click)="deleteUser()"
        nbButton
        status="primary"
        label="Eliminar usuario"></button>
    </div>
  </div>
</p-card>
